import { Card } from "@/components/ui/card";
import { FileVideo } from "lucide-react";

// Simple component for CiR campaigns - just shows published videos
export const SimpleTotalVideosCard = ({
  publishedCount,
}: {
  publishedCount: number;
}) => {
  return (
    <Card className="p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-primary/60">Total Videos</h3>
        <FileVideo className="h-5 w-5 text-primary/60" />
      </div>
      <div className="mt-2">
        <p className="text-3xl font-semibold text-primary">{publishedCount}</p>
        <p className="text-sm text-primary/60">published</p>
      </div>
    </Card>
  );
};
